import { Injectable } from "@angular/core";
import { ProductServiceInterface } from "@app/models/interfaces/product-service.interface";
import { TaqmanSearchResponseInterface } from "@app/models/responses/taqman-search-response.interface";
import { GEProductInterface } from '@app/products/ge/assays/models/interfaces/ge-product.interface';

@Injectable({providedIn: "root"})
export class GEProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): GEProductInterface[] {

        return searchResult.products.map((product) => {

            const newProduct: GEProductInterface = {
                alleleFreq: product.alleleFreq,
                ampliconLength: product.ampliconLength,
                assayDesign: product.assayDesign,
                availability: product.availability,
                defaultCatalogNum: product.defaultCatalogNum,
                defaultDye: product.defaultDye,
                defaultSize: product.defaultSize,
                dyeSizeData: product.dyeSizeData,
                genBankMrnas: product.genBankMrnas,
                geneAliases: product.geneAliases,
                geneNames: product.geneNames,
                geneSymbol: product.geneSymbol,
                genes: product.genes,
                isQualified: product.isQualified,
                packageId: product.packageId,
                plateSubType: product.plateSubType,
                productID: product.productID,
                productName: product.productName,
                productSubType: product.productSubType,
                productType: product.productType,
                recommended: product.recommended,
                refSeq: product.refSeq,
                selectedAvailability: product.availability,
                selectedCatalogNumber: product.defaultCatalogNum,
                selectedDye: product.defaultDye,
                selectedSize: product.defaultSize,
                species: product.species,
                taqmanProductID: product.productID, // unique ID for the UI
                threePrimeMost: product.threePrimeMost,
                transcripts: product.transcripts,
                webID: product.webID
            }

            return newProduct;

        });

    }

}
